/**
 * RFC 5322 official standard: https://emailregex.com/
 *
 * Deliberately a copy of `~/eds/src/utils/testIsEmailValid`: this page is being
 * taken off EDS 1.0, and relocating that module would drag three unrelated
 * legacy consumers into the change.
 */
export function testIsEmailValid(email: string | null) {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email ?? '',
  );
}
